import logo from './../../Styles/images/logo.png'
import dashboard from './../../Styles/Icons/dashboard.png'
import users from './../../Styles/Icons/users.png'
import clock from './../../Styles/Icons/clock.png'
import table from './../../Styles/Icons/table.png'
import paigesVinesLogo from './../../Styles/Logos/paigesVineyardLogoTransparent.png';
import paigesVinesCarlton from './../../Styles/Logos/paigesVineyardCarlton.png';
import pvBottle from './../../Styles/Logos/pvBottle.png';
import account from './../../Styles/Icons/account.png';
import React from "react";
import Image from "react-bootstrap/Image";
import { Container,Row,Col, Card } from "react-bootstrap";

import PropTypes from 'prop-types';
import CardHeader from 'react-bootstrap/esm/CardHeader'

import AdminDashboardContainer from '../AdminDashboard/AdminDashboardContainer'
import AdminUsersContainer from '../AdminUsers/AdminUsersContainer'
import AdminHoursContainer from '../AdminHours/AdminHoursContainer'
import AdminTablesContainer from '../AdminTables/AdminTablesContaner'

const BodySelectionComponent = props => {

    function handleClick(selection){
        props.updateSubTab(selection)
    }

    switch(props.subTab){
        case 'dashboard':
            return(
            <>
                <AdminDashboardContainer 
                    subTab={props.subTab} updateSubTab={props.updateSubTab}
                /> 
                
            </>
            )
        case 'users':
            return(
            <>
                <AdminUsersContainer/>
            </>
            )
        case 'hours':
            return(
            <>
                <AdminHoursContainer/>
            </>
            )
        case 'tables':
            return(
            <>
                <AdminTablesContainer/>
            </>
            )
        default:
            return(
                <> 
                <Container style={{ height:'90vh',display:'flex',alignItems:'center',alignContent:'center',justifyContent:'center',justifyItems:'center'}}>
                    <Col style={{padding:'10vh'}}>
                        <Card style={{backgroundColor:'#d1d1ca',cursor:'pointer'}} onClick={()=>handleClick('dashboard')}>
                            <Card.Body><Image style={{backgroundColor:'#d1d1ca'}} src={paigesVinesLogo} thumbnail></Image>
                           
                            </Card.Body>
                            
                        </Card>
                    </Col>
                    
                    <Col style={{padding:'10vh'}}>
                        <Card style={{backgroundColor:'#d1d1ca'}}>
                            <Card.Body><Image style={{backgroundColor:'#d1d1ca'}} src={paigesVinesCarlton} thumbnail></Image></Card.Body>
                        </Card>
                    </Col>

                    <Col style={{padding:'10vh'}}>
                        <Card style={{backgroundColor:'#d1d1ca'}}>
                            <CardHeader>Western Vines</CardHeader>
                            <Card.Body>This is a card for an additional Vineyard owned by the same company</Card.Body>
                        </Card>
                    </Col>
                    
                </Container>
                </>
               
            )
    }

}

BodySelectionComponent.defaultProps = {

}
BodySelectionComponent.propTypes = {
    subTab: PropTypes.string,
    updateSubTab:PropTypes.func,
    view: PropTypes.string,
    updateView:PropTypes.func,
}

const AdminComponent = props => {

    function handleClick(tab){
        props.updateSubTab(tab);
    }

    switch(props.sidePannel){
        case 'open':
            return(
                <> 
                {/** May not need to pop open sidebar for now */}
                open
                </>
               
            )
        default:
            return(
                <>
                    <div style={{height:'100vh', width:'100vw', backgroundColor:'#e3e7e0'}}>
                    <Row>
                        <Col xs='1'  style={{height:'100vh', width:'6vw', backgroundColor:'#adba96',boxShadow:'5px 0px 10px #cfd6c1'}}>
                            <Col style={{marginLeft:'1vw'}}>

                                <Row style={{paddingTop:'2vh'}}>
                                    <Image src={logo} roundedCircle onClick={()=>handleClick('home')} style={{cursor:'pointer'}}></Image>
                                </Row>
                     
                                <br></br>
                                <Row>
                                    <Image  src={dashboard} roundedCircle onClick={()=>handleClick('dashboard')} style={{cursor:'pointer'}}></Image>
                                </Row>
                                <br></br>
                                <Row>
                                    <Image src={users} roundedCircle onClick={()=>handleClick('users')} style={{cursor:'pointer'}}></Image>
                                </Row>
                                <br></br>
                                <Row>
                                    <Image src={clock} roundedCircle onClick={()=>handleClick('hours')} style={{cursor:'pointer'}}></Image>
                                </Row>
                                <br></br>
                                <Row>
                                    <Image src={table} roundedCircle onClick={()=>handleClick('tables')} style={{cursor:'pointer'}}></Image>
                                </Row>
                            </Col>
                        </Col>
                        <Col>
                            <Col style={{color:'#4e6437', fontWeight:'bold', fontSize:'2vh',justifyContent:'right', display:'flex',padding:'2vh',paddingRight:'3vw'}}>
                                <Image src={pvBottle} style={{height:'3vh', paddingRight:'1vw'}}></Image>
                                Paige's Vineyard
                                <Image src={account} style={{height:'4vh', paddingLeft:'1vw'}}></Image>
                            </Col>

                            <BodySelectionComponent 
                                subTab={props.subTab} updateSubTab={props.updateSubTab}
                                view={props.view} updateView={props.updateView}
                            />
                        </Col>
                    </Row>
                    </div>
                 </>
                );
     }

    
}

AdminComponent.defaultProps = {

}
AdminComponent.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,

    sidePannel: PropTypes.string,
    updateSidePannel:PropTypes.func,

    subTab: PropTypes.string,
    updateSubTab:PropTypes.func,

    view: PropTypes.string,
    updateView:PropTypes.func,
}

export default (AdminComponent);